import './src/styles/global.css';

import React from 'react';
import Stores from './src/context';
import LiveChatLayout from './src/components/LiveChatLayout';

export function wrapRootElement({ element, props }) {
  return (
    <Stores {...props}>
      <LiveChatLayout>{element}</LiveChatLayout>
    </Stores>
  );
}
